import axios from 'axios';
import alert_mixin from '@/utils/mixins/alert_mixin';
import BindSubEntities from '@/views/config_views/EntityManagement/CreateSubEntities/BindSubEntities.vue';
import BindTemplates from '@/views/config_views/TemplateManagement/BindTemplates/BindTemplates.vue';
import BindDocuments from '@/views/config_views/DocumentsManagement/BindDocuments/BindDocuments.vue';
import WorkflowBinding from '@/views/config_views/WorkflowManagement/WorkflowBinding/WorkflowBinding.vue';
import BindService from '@/views/config_views/AutoVerificationManagment/BindServices/BindServices.vue'
import ServiceLayerBindings from '@/views/config_views/ServiceLayerManagment/service_layer_bindings/ServiceLayerBindings.vue'
import BindRiskFramework from '@/views/config_views/RiskManagement/BindRiskFramework/BindRiskFramework.vue';
import { fetch_entity_type_workflows } from '@/services/workflow_service';
import { fetch_form_structure } from '@/services/main_section_service';
import {
  CREATE_ENTITY_CONFIG_URL,
  CREATE_FORM_BINDING_URL,
  CREATE_WORKFLOW_BINDING_URL,
  CREATE_RULE_BINDING_URL,
  GET_COMPLIANCE_RULES_URL,
  GET_FORMS_URL,
  GET_FULL_CONFIG_BY_ENTITY_TYPE_URL,
  GET_RISK_BINDINGS_URL,
  REMOVE_FORM_BINDING_URL,
  REMOVE_WORKFLOW_BINDING_URL,
  REMOVE_RULE_BINDING_URL,
  VIEW_ENTITY_TYPE_URL,
  get_request_config
} from '@/utils/system_constants/constant.js';
import ManualVerificationBinding from "@/views/config_views/ManualVerificationManagment/ManualVerificationBinding/ManualVerificationBinding.vue"
export default {
  name: 'EntitySubsystemBindings',
  mixins: [alert_mixin],
  components: {
    BindTemplates,
    BindDocuments,
    WorkflowBinding,
    BindService,
    ServiceLayerBindings,
    BindSubEntities,
    ManualVerificationBinding,
    BindRiskFramework
  },
  data: () => ({

      active_tab: 'forms',
      tabs: [
        { key: 'forms', label: 'Forms' },
        { key: 'template', label: 'Template' },
        { key: 'documents', label: 'Documents' },
        { key: 'workflow', label: 'Workflow' },
        { key: 'rules', label: 'Rules' },
        { key: 'risk', label: 'Risk' },
        { key: 'auto_verification', label: 'Auto Verification' },
        { key: 'manual_verification', label: 'Manual Verification' },
        { key: 'children', label: 'Children' },
        { key: 'sla', label: 'SLA'},
        { key: 'schema', label: 'Schema' },
        { key: 'history', label: 'History' }
      ],
      entity_type: {},
      entity_config: {},
      form_bindings: [],
      workflow_bindings: [],
      rule_bindings: [],
      risk_bindings: [],
      document_bindings: [],
      document_group_bindings: [],
      available_forms: [],
      available_workflows: [],
      available_rules: [],
      selected_form_ids: [],
      selected_unique_question_ids_by_form_id: [],
      form_questions_by_form_id: [],
      loading_form_question_ids: [],
      form_dropdown_open: false,
      selected_workflow_ids: [],
      selected_rule_ids: [],
      rule_dropdown_open: false,
      selected_priority: 0,
      creating_binding: false,
      creating_workflow_binding: false,
      creating_rule_binding: false
  }),
  computed: {
    entity_type_id() {
      return Number(this.$route.params.entityTypeId);
    },
    entity_type_name() {
      return (
        this.entity_type.entity_type_name ||
        this.entity_config.entity_type_name ||
        this.entity_config.entity_type?.entity_type_name ||
        'Entity'
      );
    },
    system_name() {
      return `ent_${String(this.entity_type_name || 'entity')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, '_')}_v${this.entity_config.version || 1}`;
    },
    project_id() {
      return (
        this.entity_type.project_id ||
        this.entity_config.project_id ||
        this.entity_type.project?.id ||
        null
      );
    },
    bindable_forms() {
      const boundFormIds = new Set(
        (this.form_bindings || [])
          .map((binding) => Number(
            binding.form ||
            binding.form_id ||
            binding.form_template_id
          ))
          .filter((id) => Number.isFinite(id) && id > 0)
      );

      return (this.available_forms || []).filter(
        (form) => !boundFormIds.has(Number(form.id))
      );
    },
    bindable_rules() {
      const boundRuleIds = new Set(
        (this.rule_bindings || [])
          .map((binding) => Number(
            binding.compliance_rule ||
            binding.compliance_rule_id ||
            binding.compliance_rule?.id ||
            binding.rule_id ||
            binding.rule
          ))
          .filter((id) => Number.isFinite(id) && id > 0)
      );
      const boundRuleNames = new Set(
        (this.rule_bindings || [])
          .map((binding) => this.normalize_binding_name(
            binding.rule_name ||
            binding.name ||
            binding.compliance_rule_name ||
            binding.compliance_rule?.name
          ))
          .filter(Boolean)
      );

      return (this.available_rules || []).filter(
        (rule) => (
          !boundRuleIds.has(Number(rule.id)) &&
          !boundRuleNames.has(this.normalize_binding_name(rule.name))
        )
      );
    },
    bindable_workflows() {
      const boundWorkflowIds = new Set(
        (this.workflow_bindings || []).map((binding) => Number(
          binding.workflow
          || binding.entity_type_workflow
          || binding.workflow_id
          || binding.entity_type_workflow_id
        ))
      );

      return (this.available_workflows || []).filter(
        (workflow) => !boundWorkflowIds.has(Number(workflow.id))
      );
    },
    subsystem_metrics() {
      return [
        { label: 'Forms', value: this.form_bindings.length, icon: 'bi-file-earmark-text' },
        { label: 'Documents', value: this.document_group_bindings.length || this.document_bindings.length, icon: 'bi-file-earmark-check' },
        { label: 'Workflows', value: this.workflow_bindings.length, icon: 'bi-diagram-3' },
        { label: 'Rules', value: this.rule_bindings.length, icon: 'bi-sliders' }
      ];
    },
    selected_forms_count() {
      return Array.isArray(this.selected_form_ids) ? this.selected_form_ids.length : 0;
    },
    selected_rules_count() {
      return Array.isArray(this.selected_rule_ids) ? this.selected_rule_ids.length : 0;
    },
    selected_forms_label() {
      if (!this.bindable_forms.length) return 'No forms available';
      if (!this.selected_forms_count) return 'Select form(s) to bind';
      return `${this.selected_forms_count} form${this.selected_forms_count === 1 ? '' : 's'} selected`;
    },
    selected_bindable_forms() {
      const selectedIds = new Set(
        (this.selected_form_ids || []).map((id) => String(id))
      );
      return (this.bindable_forms || []).filter((form) =>
        selectedIds.has(String(form.id))
      );
    },
    selected_rules_label() {
      if (!this.bindable_rules.length) return 'No unbound rules available';
      if (!this.selected_rules_count) return 'Select rule(s) to bind';
      return `${this.selected_rules_count} rule${this.selected_rules_count === 1 ? '' : 's'} selected`;
    }
  },
  watch: {
    selected_form_ids: {
      handler() {
        this.prepare_selected_form_unique_questions();
      },
      deep: true
    },
    '$route.query.tab'() {
      this.apply_route_state();
    }
  },
  mounted() {
    this.load_page();
    document.addEventListener('click', this.on_document_click, true);
    this.apply_route_state();
  },
  beforeUnmount() {
    document.removeEventListener('click', this.on_document_click, true);
  },
  methods: {
    apply_route_state() {
      const tab = String(this.$route?.query?.tab || 'forms');
      this.active_tab = this.tabs.some((item) => item.key === tab) ? tab : 'forms';
    },

    on_document_click(event) {
      if (!this.form_dropdown_open && !this.rule_dropdown_open) return;

      const formRoot = this.$refs?.formMultiselect;
      if (this.form_dropdown_open && formRoot && !formRoot.contains(event.target)) {
        this.form_dropdown_open = false;
      }

      const ruleRoot = this.$refs?.ruleMultiselect;
      if (this.rule_dropdown_open && ruleRoot && !ruleRoot.contains(event.target)) {
        this.rule_dropdown_open = false;
      }
    },
    toggle_form_dropdown() {
      if (this.creating_binding) return;
      this.form_dropdown_open = !this.form_dropdown_open;
      if (this.form_dropdown_open) this.fetch_available_forms();
    },
    is_loading_form_questions(form_id) {
      return (this.loading_form_question_ids || []).includes(String(form_id));
    },
    normalize_form_key(form_id) {
      const key = Number(form_id);
      return Number.isFinite(key) && key > 0 ? key : null;
    },
    find_form_record(records, form_id) {
      const key = this.normalize_form_key(form_id);
      if (!key) return null;

      return (Array.isArray(records) ? records : [])
        .find((record) => Number(record.form_id) === key) || null;
    },
    get_selected_unique_question_ids(form_id) {
      const record = this.find_form_record(
        this.selected_unique_question_ids_by_form_id,
        form_id
      );

      return Array.isArray(record?.question_ids) ? record.question_ids : [];
    },
    set_selected_unique_question_ids(form_id, question_ids) {
      const key = this.normalize_form_key(form_id);
      if (!key) return;

      const records = Array.isArray(this.selected_unique_question_ids_by_form_id)
        ? this.selected_unique_question_ids_by_form_id
        : [];
      const nextRecord = {
        form_id: key,
        question_ids: Array.isArray(question_ids) ? question_ids : []
      };
      const existingIndex = records.findIndex((record) => Number(record.form_id) === key);

      this.selected_unique_question_ids_by_form_id = existingIndex >= 0
        ? records.map((record, index) => (index === existingIndex ? nextRecord : record))
        : [...records, nextRecord];
    },
    get_form_questions(form_id) {
      const record = this.find_form_record(this.form_questions_by_form_id, form_id);
      return Array.isArray(record?.questions) ? record.questions : [];
    },
    set_form_questions(form_id, questions) {
      const key = this.normalize_form_key(form_id);
      if (!key) return;

      const records = Array.isArray(this.form_questions_by_form_id)
        ? this.form_questions_by_form_id
        : [];
      const nextRecord = {
        form_id: key,
        questions: Array.isArray(questions) ? questions : []
      };
      const existingIndex = records.findIndex((record) => Number(record.form_id) === key);

      this.form_questions_by_form_id = existingIndex >= 0
        ? records.map((record, index) => (index === existingIndex ? nextRecord : record))
        : [...records, nextRecord];
    },
    is_unique_question_selected(form_id, question_id) {
      return this.get_selected_unique_question_ids(form_id)
        .map((id) => Number(id))
        .includes(Number(question_id));
    },
    toggle_unique_question_selection(form_id, question_id, isSelected) {
      const selectedIds = this.get_selected_unique_question_ids(form_id)
        .map((id) => Number(id))
        .filter((id) => Number.isFinite(id) && id > 0);
      const normalizedQuestionId = Number(question_id);

      if (!Number.isFinite(normalizedQuestionId) || normalizedQuestionId <= 0) return;

      const nextIds = isSelected
        ? Array.from(new Set([...selectedIds, normalizedQuestionId]))
        : selectedIds.filter((id) => id !== normalizedQuestionId);

      this.set_selected_unique_question_ids(form_id, nextIds);
    },
    get_question_id(question) {
      return Number(
        question?.question_id ||
        question?.id ||
        question?.question?.id
      );
    },
    get_question_text(question, index) {
      return (
        question?.question_text ||
        question?.question?.question_text ||
        `Question ${index + 1}`
      );
    },
    get_question_section_name(question, fallback_section_name) {
      return (
        question?.section_name ||
        question?.sub_section_name ||
        question?.section?.name ||
        fallback_section_name ||
        ''
      );
    },
    normalize_question_option(question, index = 0, fallback_section_name = '') {
      const id = this.get_question_id(question);
      if (!Number.isFinite(id) || id <= 0) return null;

      const option = {
        id,
        question_text: this.get_question_text(question, index),
        section_name: this.get_question_section_name(question, fallback_section_name)
      };

      return option;
    },
    collect_questions_from_form_structure(items) {
      const questionsById = new Map();
      const addQuestion = (question, index = 0, sectionName = '') => {
        const option = this.normalize_question_option(question, index, sectionName);
        if (option && !questionsById.has(option.id)) {
          questionsById.set(option.id, option);
        }
      };

      (Array.isArray(items) ? items : []).forEach((mainSection) => {
        const subSections = Array.isArray(mainSection?.sub_sections)
          ? mainSection.sub_sections
          : [];
        subSections.forEach((subSection) => {
          const sectionName =
            subSection?.section_name ||
            subSection?.name ||
            mainSection?.main_section_name ||
            mainSection?.name ||
            '';
          (Array.isArray(subSection?.questions) ? subSection.questions : [])
            .forEach((question, index) => addQuestion(question, index, sectionName));
        });

        (Array.isArray(mainSection?.questions) ? mainSection.questions : [])
          .forEach((question, index) =>
            addQuestion(
              question,
              index,
              mainSection?.main_section_name || mainSection?.name || ''
            )
          );
      });

      return Array.from(questionsById.values());
    },
    async load_form_questions_for_binding(form_id) {
      const key = this.normalize_form_key(form_id);
      if (!key || this.find_form_record(this.form_questions_by_form_id, key)) return;

      this.loading_form_question_ids = Array.from(
        new Set([...this.loading_form_question_ids, String(key)])
      );
      try {
        const structure = await fetch_form_structure(form_id);
        this.set_form_questions(key, this.collect_questions_from_form_structure(structure));
      } catch {
        this.set_form_questions(key, []);
      } finally {
        this.loading_form_question_ids = this.loading_form_question_ids
          .filter((id) => id !== String(key));
      }
    },
    prepare_selected_form_unique_questions() {
      (this.selected_form_ids || []).forEach((form_id) => {
        if (!this.find_form_record(this.selected_unique_question_ids_by_form_id, form_id)) {
          this.set_selected_unique_question_ids(form_id, []);
        }
        this.load_form_questions_for_binding(form_id);
      });
    },
    format_binding_unique_summary(binding) {
      if (!binding?.unique_answers_configured) {
        return 'Unique answers have not been configured on this binding yet.';
      }
      const count = Array.isArray(binding?.unique_question_ids)
        ? binding.unique_question_ids.length
        : 0;
      if (!count) return 'No unique answers configured for this binding.';
      return `${count} unique answer question${count === 1 ? '' : 's'} for this entity type in this project.`;
    },
    toggle_rule_dropdown() {
      if (this.creating_rule_binding) return;
      this.rule_dropdown_open = !this.rule_dropdown_open;
      if (this.rule_dropdown_open) this.fetch_available_rules();
    },
    normalize_binding_name(value) {
      return String(value || '').trim().toLowerCase();
    },

    parse_response_data(payload) {
      let result = payload;

      if (typeof payload === 'string') {
        const trimmedPayload = payload.trim();

        if (!trimmedPayload) {
          result = {};
        } else {
          try {
            result = JSON.parse(trimmedPayload);
          } catch {
            result = {};
          }
        }
      }

      return result;
    },

    async fetch_entity_type() {
      const response = await axios.get(
        VIEW_ENTITY_TYPE_URL,
        get_request_config({
          params: {
            entity_type_id: this.entity_type_id
          }
        })
      );

      const responseData = this.parse_response_data(response.data);
      const items = responseData.data || [];
      this.entity_type = Array.isArray(items)
        ? (items.find((item) => Number(item.id) === this.entity_type_id) || items[0] || {})
        : items;
    },

    async fetch_full_config() {
      const response = await axios.get(
        GET_FULL_CONFIG_BY_ENTITY_TYPE_URL,
        get_request_config({
          params: {
            entity_type_id: this.entity_type_id
          }
        })
      );

      const responseData = this.parse_response_data(response.data);
      return responseData.data || {};
    },

    resolve_entity_config_id(entity_config_id = this.entity_config?.id || null) {
      const resolved_entity_config_id = Number(entity_config_id);
      return Number.isFinite(resolved_entity_config_id) && resolved_entity_config_id > 0
        ? resolved_entity_config_id
        : null;
    },

    handle_risk_bindings_error(error, fallback_message) {
      const responseData = this.parse_response_data(error?.response?.data || {});
      this.show_error(responseData.message || fallback_message);
    },

    async fetch_risk_bindings(entity_config_id = this.entity_config?.id || null) {
      const resolved_entity_config_id = this.resolve_entity_config_id(entity_config_id);
      if (!resolved_entity_config_id) return [];

      try {
        const response = await axios.get(
          GET_RISK_BINDINGS_URL,
          get_request_config({
            params: {
              entity_config_id: resolved_entity_config_id
            }
          })
        );

        const responseData = this.parse_response_data(response.data);
        return Array.isArray(responseData.data) ? responseData.data : [];
      } catch (error) {
        this.handle_risk_bindings_error(error, 'Failed to load risk bindings.');
        return [];
      }
    },

    ensure_entity_config_exists() {
      const promise = this.fetch_full_config().catch(async (error) => {
        if (error?.response?.status !== 404) {
          throw error;
        }

        await axios.post(
          CREATE_ENTITY_CONFIG_URL,
          { entity_type_id: this.entity_type_id },
          get_request_config()
        );

        const fetched = await this.fetch_full_config();
        return fetched;
      });

      return promise;
    },

    fetch_available_forms() {
      const result = axios
        .get(
          GET_FORMS_URL,
          get_request_config({
            params: this.project_id ? { project_id: this.project_id } : {}
          })
        )
        .then((response) => {
          const responseData = this.parse_response_data(response.data);
          const rawForms = responseData.data || responseData || [];

          this.available_forms = (Array.isArray(rawForms) ? rawForms : [])
            .map((form) => ({
              id: form.id || form.form_id,
              form_name: form.form_name || form.name || `Form ${form.id || form.form_id}`
            }))
            .filter((form) => form.id);

          const output = this.available_forms;
          return output;
        })
        .catch(() => {
          this.available_forms = [];
          const output = this.available_forms;
          return output;
        });

      return result;
    },

    async load_page() {
      const loader = await this.show_loader('Loading subsystem bindings...');

      try {
        await this.fetch_entity_type();
        const configData = await this.ensure_entity_config_exists();
        this.entity_config = configData.entity_config || {};
        this.form_bindings = configData.form_bindings || [];
        this.workflow_bindings = configData.workflow_bindings || [];
        this.rule_bindings = configData.rule_bindings || [];
        this.document_bindings = configData.document_bindings || [];
        this.document_group_bindings = configData.document_group_bindings || [];
        this.risk_bindings = await this.fetch_risk_bindings(this.entity_config?.id);
        await this.fetch_available_forms();
        await this.fetch_available_workflows();
        await this.fetch_available_rules();
      } catch (error) {
        const responseData = this.parse_response_data(error?.response?.data || {});
        this.show_error(responseData.message || 'Failed to load subsystem bindings.');
      } finally {
        await this.close_loader(loader);
      }
    },

    describe_binding(binding) {
      return binding.priority === 0
        ? 'Captures base entity information and primary onboarding details.'
        : 'Supports secondary validation, compliance, or additional entity inputs.';
    },

    describe_rule_binding(binding) {
      return `${binding.logical_operator || 'AND'} logic${binding.rule_version ? ` · version ${binding.rule_version}` : ''}`;
    },

    get_binding_id(binding) {
      return Number(binding?.id);
    },

    get_workflow_binding_workflow_id(binding) {
      return Number(
        binding?.workflow
        || binding?.entity_type_workflow
        || binding?.workflow_id
        || binding?.entity_type_workflow_id
      );
    },

    should_keep_workflow_binding(item, target_binding) {
      const item_binding_id = this.get_binding_id(item);
      const target_binding_id = this.get_binding_id(target_binding);

      if (item_binding_id && target_binding_id) {
        return item_binding_id !== target_binding_id;
      }

      const item_workflow_id = this.get_workflow_binding_workflow_id(item);
      const target_workflow_id = this.get_workflow_binding_workflow_id(target_binding);

      if (item_workflow_id && target_workflow_id) {
        return item_workflow_id !== target_workflow_id;
      }

      return true;
    },

    async fetch_available_rules() {
      try {
        const response = await axios.get(
          GET_COMPLIANCE_RULES_URL,
          get_request_config()
        );
        const responseData = this.parse_response_data(response.data);
        const rawRules = responseData.rules || responseData.data || [];

        this.available_rules = (Array.isArray(rawRules) ? rawRules : [])
          .map((rule) => ({
            id: rule.id,
            name: rule.name || `Rule ${rule.id}`,
            description: rule.description || '',
            logical_operator: rule.logical_operator || 'AND',
            entity_type: rule.entity_type ?? null,
          }))
          .filter((rule) => rule.id)
          .filter((rule, index, rules) =>
            rules.findIndex((entry) => Number(entry.id) === Number(rule.id)) === index
          )
          .filter((rule, index, rules) =>
            rules.findIndex((entry) =>
              this.normalize_binding_name(entry.name) === this.normalize_binding_name(rule.name)
            ) === index
          );
      } catch (error) {
        this.available_rules = [];
      }
    },

    async fetch_available_workflows() {
      try {
        const workflows = await fetch_entity_type_workflows();
        this.available_workflows = (Array.isArray(workflows) ? workflows : [])
          .map((workflow) => ({
            id: workflow.id,
            name: workflow.name || workflow.workflow_name || `Workflow ${workflow.id}`,
            description: workflow.description || '',
            status: workflow.workflow_status || workflow.status || 'NEW',
          }))
          .filter((workflow) => workflow.id);
      } catch (error) {
        this.available_workflows = [];
      }
    },

    format_rule_option(rule) {
      if (!rule) return '';
      const scope = rule.entity_type ? 'Scoped' : 'Global';
      return `${rule.name} (${scope})`;
    },

    async add_form_bindings() {
      const selected_ids = Array.isArray(this.selected_form_ids)
        ? this.selected_form_ids.map((id) => String(id)).filter(Boolean)
        : [];

      if (!selected_ids.length) {
        this.show_error('Please select at least one form to bind.');
        return;
      }

      this.creating_binding = true;

      try {
        const unique_ids = Array.from(new Set(selected_ids));
        const successes = [];
        const failures = [];
        const priority = Number(this.selected_priority) || 0;

        for (const raw_id of unique_ids) {
          const form_id = Number(raw_id);
          if (!Number.isFinite(form_id) || form_id <= 0) {
            failures.push({ form_id: raw_id, message: 'Invalid form selected.' });
            continue;
          }

          try {
            const response = await axios.post(
              CREATE_FORM_BINDING_URL,
              {
                entity_config_id: this.entity_config.id,
                form_id,
                priority,
                unique_question_ids: this.get_selected_unique_question_ids(form_id)
                  .map((id) => Number(id))
                  .filter((id) => Number.isFinite(id) && id > 0)
              },
              get_request_config()
            );

            const responseData = this.parse_response_data(response.data);
            const createdBinding = responseData.data;
            if (createdBinding) {
              this.form_bindings = this.sort_bindings([
                ...this.form_bindings.filter((item) => item.id !== createdBinding.id),
                createdBinding
              ]);
            } else {
              const configData = await this.fetch_full_config();
              this.form_bindings = configData.form_bindings || [];
            }

            successes.push(form_id);
          } catch (error) {
            const responseData = this.parse_response_data(error?.response?.data || {});
            failures.push({ form_id, message: responseData.message || 'Failed to create form binding.' });
          }
        }

        await this.fetch_available_forms();

        if (successes.length) {
          this.show_success(`${successes.length} form${successes.length === 1 ? '' : 's'} bound successfully.`);
        }

        if (failures.length) {
          this.show_error(
            failures.length === 1
              ? (failures[0]?.message || 'Failed to create form binding.')
              : `${failures.length} form${failures.length === 1 ? '' : 's'} failed to bind.`
          );
        }

        this.selected_form_ids = failures.map((failure) => String(failure.form_id)).filter(Boolean);
        if (!failures.length) {
          this.selected_priority = 0;
          this.selected_unique_question_ids_by_form_id = [];
        }
        this.form_dropdown_open = false;
      } finally {
        this.creating_binding = false;
      }
    },

    async delete_form_binding(binding) {
      try {
        const response = await axios.post(
          REMOVE_FORM_BINDING_URL,
          { binding_id: binding.id },
          get_request_config()
        );
        const responseData = this.parse_response_data(response.data);
        this.form_bindings = this.form_bindings.filter((item) => item.id !== binding.id);
        await this.fetch_available_forms();
        this.show_success(responseData.message || 'Form binding removed.');
      } catch (error) {
        const responseData = this.parse_response_data(error?.response?.data || {});
        this.show_error(responseData.message || 'Failed to remove form binding.');
      }
    },

    remove_form_binding(binding) {
      this.show_confirm(
        'Remove Form Binding?',
        `Are you sure you want to remove ${binding.form_name || 'this form binding'}?`,
        () => this.delete_form_binding(binding)
      );
    },

    async add_workflow_bindings() {
      const selected_ids = Array.isArray(this.selected_workflow_ids)
        ? this.selected_workflow_ids.map((id) => String(id)).filter(Boolean)
        : [];

      if (!selected_ids.length) {
        this.show_error('Please select at least one workflow to bind.');
        return;
      }

      this.creating_workflow_binding = true;

      try {
        const unique_ids = Array.from(new Set(selected_ids));
        const successes = [];
        const failures = [];

        for (const raw_id of unique_ids) {
          const entity_type_workflow_id = Number(raw_id);
          if (!Number.isFinite(entity_type_workflow_id) || entity_type_workflow_id <= 0) {
            failures.push({ entity_type_workflow_id: raw_id, message: 'Invalid workflow selected.' });
            continue;
          }

          try {
            const response = await axios.post(
              CREATE_WORKFLOW_BINDING_URL,
              {
                entity_config_id: this.entity_config.id,
                entity_type_workflow_id,
              },
              get_request_config()
            );

            const responseData = this.parse_response_data(response.data);
            const createdBinding = responseData.data;

            if (createdBinding) {
              this.workflow_bindings = [
                ...this.workflow_bindings.filter((item) => item.id !== createdBinding.id),
                createdBinding,
              ];
            } else {
              const configData = await this.fetch_full_config();
              this.workflow_bindings = configData.workflow_bindings || [];
            }

            successes.push(entity_type_workflow_id);
          } catch (error) {
            const responseData = this.parse_response_data(error?.response?.data || {});
            failures.push({
              entity_type_workflow_id,
              message: responseData.message || 'Failed to create workflow binding.',
            });
          }
        }

        await this.fetch_available_workflows();

        if (successes.length) {
          this.show_success(`${successes.length} workflow${successes.length === 1 ? '' : 's'} bound successfully.`);
        }

        if (failures.length) {
          this.show_error(
            failures.length === 1
              ? (failures[0]?.message || 'Failed to create workflow binding.')
              : `${failures.length} workflow${failures.length === 1 ? '' : 's'} failed to bind.`
          );
        }

        this.selected_workflow_ids = failures.map((failure) => String(failure.entity_type_workflow_id)).filter(Boolean);
      } finally {
        this.creating_workflow_binding = false;
      }
    },

    async delete_workflow_binding(binding) {
      try {
        const response = await axios.post(
          REMOVE_WORKFLOW_BINDING_URL,
          { binding_id: binding.id },
          get_request_config()
        );
        const responseData = this.parse_response_data(response.data);
        this.workflow_bindings = this.workflow_bindings.filter((item) =>
          this.should_keep_workflow_binding(item, binding)
        );
        await this.fetch_available_workflows();
        this.show_success(responseData.message || 'Workflow binding removed.');
      } catch (error) {
        const responseData = this.parse_response_data(error?.response?.data || {});
        this.show_error(responseData.message || 'Failed to remove workflow binding.');
      }
    },

    async add_rule_bindings() {
      const selected_ids = Array.isArray(this.selected_rule_ids)
        ? this.selected_rule_ids.map((id) => String(id)).filter(Boolean)
        : [];

      if (!selected_ids.length) {
        this.show_error('Please select at least one rule to bind.');
        return;
      }

      this.creating_rule_binding = true;

      try {
        const unique_ids = Array.from(new Set(selected_ids));
        const successes = [];
        const failures = [];

        for (const raw_id of unique_ids) {
          const compliance_rule_id = Number(raw_id);
          if (!Number.isFinite(compliance_rule_id) || compliance_rule_id <= 0) {
            failures.push({ compliance_rule_id: raw_id, message: 'Invalid rule selected.' });
            continue;
          }

          try {
            const response = await axios.post(
              CREATE_RULE_BINDING_URL,
              {
                entity_config_id: this.entity_config.id,
                compliance_rule_id
              },
              get_request_config()
            );

            const responseData = this.parse_response_data(response.data);
            const createdBinding = responseData.data;
            if (createdBinding) {
              this.rule_bindings = [
                ...this.rule_bindings.filter((item) => item.id !== createdBinding.id),
                createdBinding
              ];
            } else {
              const configData = await this.fetch_full_config();
              this.rule_bindings = configData.rule_bindings || [];
            }

            successes.push(compliance_rule_id);
          } catch (error) {
            const responseData = this.parse_response_data(error?.response?.data || {});
            failures.push({ compliance_rule_id, message: responseData.message || 'Failed to create rule binding.' });
          }
        }

        await this.fetch_available_rules();

        if (successes.length) {
          this.show_success(`${successes.length} rule${successes.length === 1 ? '' : 's'} bound successfully.`);
        }

        if (failures.length) {
          this.show_error(
            failures.length === 1
              ? (failures[0]?.message || 'Failed to create rule binding.')
              : `${failures.length} rule${failures.length === 1 ? '' : 's'} failed to bind.`
          );
        }

        this.selected_rule_ids = failures.map((failure) => String(failure.compliance_rule_id)).filter(Boolean);
        this.rule_dropdown_open = false;
      } finally {
        this.creating_rule_binding = false;
      }
    },

    async delete_rule_binding(binding) {
      try {
        const response = await axios.post(
          REMOVE_RULE_BINDING_URL,
          { binding_id: binding.id },
          get_request_config()
        );
        const responseData = this.parse_response_data(response.data);
        this.rule_bindings = this.rule_bindings.filter((item) => item.id !== binding.id);
        await this.fetch_available_rules();
        this.show_success(responseData.message || 'Rule binding removed.');
      } catch (error) {
        const responseData = this.parse_response_data(error?.response?.data || {});
        this.show_error(responseData.message || 'Failed to remove rule binding.');
      }
    },

    remove_rule_binding(binding) {
      this.show_confirm(
        'Remove Rule Binding?',
        `Are you sure you want to remove ${binding.rule_name || 'this rule binding'}?`,
        () => this.delete_rule_binding(binding)
      );
    },

    async refresh_risk_bindings() {
      try {
        const configData = await this.fetch_full_config();
        this.entity_config = configData.entity_config || this.entity_config;
        this.risk_bindings = await this.fetch_risk_bindings(this.entity_config?.id);
      } catch (error) {
        this.handle_risk_bindings_error(error, 'Failed to refresh risk bindings.');
      }
    },

    sort_bindings(bindings) {
      return bindings.slice().sort((first, second) => {
        if ((first.priority || 0) !== (second.priority || 0)) {
          return (first.priority || 0) - (second.priority || 0);
        }
        return (first.id || 0) - (second.id || 0);
      });
    },

    go_to_entity_overview() {
      this.$router.push({
        name: 'EntityConfigDetail',
        params: {
          entityTypeId: this.entity_type_id
        }
      });
    },
    remove_workflow_binding(binding) {
      this.show_confirm(
        'Remove Workflow Binding?',
        `Are you sure you want to remove ${binding.workflow_name || binding.name || 'this workflow'}?`,
        () => this.delete_workflow_binding(binding)
      );
    }
  }
};
